<template>
    <div
        class="lni-u-mhauto lni-u-mv3"
    >
        <LniRetaliationConfirmation
            id="confirm"
        />
    </div>
</template>

<script>

export default {
    name: 'ResultPage',
}; </script>